import axios from "axios";
import LocalStorageKeys from "../data/localStorageKeys";
import { environment } from "../environments/environment";

export class CrudService {

    // URL API
    static api = environment.API_URL;
    endPoint = '';
    funcionDto = function (item) { return item; };
    funcionEntidad = function (item) { return item };

    get AuthHeader() {
        return "Token " + this.Token;
    }

    get Headers() {
        return { Authorization: this.AuthHeader };
    }

    get Token() {
        return localStorage.getItem(LocalStorageKeys.token);
    }

    /**
     * 
     * @param {String} endPoint identificador de feature para los endpoints
     * @param {Function} funcionDto función que convierte de entidad a dto, usada al editar o crear. Si no se pasa una, se enviará la entidad completa al editar o crear
     * @param {Function} funcionEntidad función que convierte de dto a entidad, usada al traer la lista. La lista quedará con los dtos sin tocar si no se pasa una
     */
    constructor(endPoint, funcionDto, funcionEntidad) {
        this.endPoint = endPoint;
        if (funcionDto) this.funcionDto = funcionDto;
        if (funcionEntidad) this.funcionEntidad = funcionEntidad;
    }

    /**
         * Cantidad de todos los items que existen
         * @param {object} filtro Objeto con parámetros
         * */
    countWithFilter(filtro) {
        const path = `${CrudService.api}${this.endPoint}/cantidad/filtro`;

        return axios.post(path, filtro, { headers: this.Headers });
    }

    /**
     * @method getAll Metodo generico para obtener todos los elementos de la entidad.
     * @returns 
     */
    getTodos(filtro) {
        const path = `${CrudService.api}${this.endPoint}/filtro`;

        return axios.post(path, filtro, { headers: this.Headers }).then(res => {
            res.data.forEach(item => this.convertirAEntidad(item));
            return Promise.resolve(res);
        })
            .catch(error => {
                return Promise.reject(error);
            });
    }

    /**
     * @method getById Metodo generico para obtener una entidad segun su ID.
     * @param id 
     * @returns 
     */
    get(id) {
        const path = `${CrudService.api}${this.endPoint}` + id;
        return axios.get(path, { headers: this.Headers });
    }

    /**
     * @method create Metodo generico para crear una entidad.
     * @param item 
     * @returns 
     */
    crear(item) {
        const path = `${CrudService.api}${this.endPoint}`;
        return axios.post(path, this.convertirADto(item), { headers: this.Headers }).then(response => {
            response.data = this.convertirAEntidad(response.data);
            return Promise.resolve(response);
        });
    }

    /**
     * @method update Metodo generico para modificar una entidad.
     * @param id 
     * @param item 
     * @returns 
     */
    editar(item) {
        const path = `${CrudService.api}${this.endPoint}`;
        return axios.put(path, this.convertirADto(item), { headers: this.Headers });
    }

    /**
     * @method deleteById Metodo generico para eliminar una entidad segun su ID.
     * @param id 
     * @returns 
     */
    eliminar(id) {
        const path = `${CrudService.api}${this.endPoint}/${id}`;
        return axios.delete(path, { headers: this.Headers });
    }

    convertirADto(item) {
        return this.funcionDto(item);
    }
    convertirAEntidad(item) {
        return this.funcionEntidad(item);
    }
}